import React from 'react';
import Skeleton from 'react-loading-skeleton';

export const SkeletonFree = () => {
  return (
    <>
      <div id="tabla-boletos-wrap">
        <div style={{ maxWidth: '860px', width: '100%', margin: '0 auto' }}>
          <div style={{ marginBottom: '30px' }}>
            <Skeleton height={80} />
          </div>
          <div style={{ marginBottom: '30px' }}>
            <Skeleton height={80} />
          </div>
        </div>
      </div>
    </>
  );
};

export const SkeletonHome = () => {
  return (
    <div className={`skel-background skel-img`}>
      <section className="mainE">
        <div className="skel-header skel-main " style={{position: `relative`,height:`61px`,marginBottom:`30px`}}></div>
        <div className="container-custom-tm">
          <span className="bg-top"></span>
          <div className="wrap-evento" style={{display: `flex`}}>
            <div className="column-left" style={{zIndex: `1`}}>
              <Skeleton height={657} />
              <div className='info-evento color-titulos'>
                <div style={{padding: `16px 20px `,maxWidth: `50%`}}>
                  <Skeleton height={30} />
                </div>
                <div style={{paddingLeft: `20px`,maxWidth: `30%`}}>
                  <Skeleton height={16} />
                </div>
              </div>
            </div>
            <div className="column-right">
              <div style={{position: `sticky`, top: `30px`, zIndex: `9999`}}>
                <Skeleton height={657} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export const SkeletonConfirmation = () => {
  return (
    <div className={`skel-background`}>
      <section className="mainE">
        <div className="container-custom-tm">
          <div className="skel-header skel-main">
            <Skeleton height={40} />
          </div>
          <div className="wrap-evento clear-fl skel-main">
            <div className="row">
              <div className="col-xs-12 col-lg-12">
                <div className="skel-img">
                  <Skeleton height={580} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
